import * as THREE from 'three';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';
import profileData from './mt150-profiles.json';
import { shapesFromContours } from './rails';

export function makeMT150Profile(family, kind, length, frame, materials, cutaway = false) {
  const group = new THREE.Group(), source = profileData[family].profiles[kind];
  group.userData = { profileCode: source.code, trackCount: profileData[family].tracks, profileDepth: source.depth_mm };
  const batches = new Map();
  for (const component of source.components) {
    const material = component.material === 'aluminium' ? frame : component.material === 'gasket' ? materials.gasket : materials.thermal;
    const geometry = new THREE.ExtrudeGeometry(shapesFromContours(component.contours), { depth: length, bevelEnabled: false, steps: 1 });
    geometry.translate(0, 0, -length / 2); geometry.rotateY(Math.PI / 2);
    if (cutaway) {
      // End faces use bare aluminium; extrusion walls retain the selected finish.
      const mesh = new THREE.Mesh(geometry, [component.material === 'aluminium' ? materials.cutAluminium : material, material]);
      mesh.castShadow = true; mesh.receiveShadow = true;
      mesh.userData = { cadProfile: source.code, cadLayer: component.layer, profileMaterial: component.material };
      group.add(mesh);
    } else {
      if (!batches.has(material)) batches.set(material, []);
      batches.get(material).push(geometry);
    }
  }
  for (const [material, geometries] of batches) {
    const geometry = geometries.length === 1 ? geometries[0] : mergeGeometries(geometries, false);
    if (geometries.length > 1) geometries.forEach(g => g.dispose());
    const mesh = new THREE.Mesh(geometry, material); mesh.castShadow = !materials.software; mesh.receiveShadow = true;
    mesh.userData.cadProfile = source.code; group.add(mesh);
  }
  if (materials.software && !cutaway) {
    // Full-door shadow proxy only: inspection uses the actual hollow profiles.
    if (!materials.mtShadowMaterial) materials.mtShadowMaterial = new THREE.MeshBasicMaterial({ colorWrite: false, depthWrite: false });
    const proxy = new THREE.Mesh(new THREE.BoxGeometry(length, source.height_mm / 1000, source.depth_mm / 1000), materials.mtShadowMaterial);
    proxy.position.y = source.height_mm / 2000; proxy.castShadow = true;
    proxy.name = 'profile-shadow-proxy'; proxy.raycast = () => {}; group.add(proxy);
  }
  return group;
}